/*======= FIXED HEADER ==========*/
$(document).ready(function () {
	var menuBackground = $('.menu-background');
	var menuOffsetTop;
	var isSticky = false;
	var rafScheduled = false;

	function updateOffsets() {
		menuOffsetTop = menuBackground.offset().top;
	}

	function applyStickyHeader() {
		var scrollTop = window.scrollY || window.pageYOffset;
		var shouldBeSticky = scrollTop >= menuOffsetTop;

		if (shouldBeSticky !== isSticky) {
			isSticky = shouldBeSticky;
			menuBackground.toggleClass('JSsticky_header', isSticky);
			menuBackground.css({
				'margin-bottom': isSticky ? menuBackground.outerHeight(true) : '',
				'animation': isSticky ? 'none' : '',
				'background-color': isSticky ? 'var(--menu_bg)' : ''
			});
		}

		rafScheduled = false;
	}

	function handleScroll() {
		if (!rafScheduled) {
			rafScheduled = true;
			requestAnimationFrame(applyStickyHeader);
		}
	}

	var resizeTimeout;
	function handleResize() {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(function () {
			updateOffsets();
			applyStickyHeader();
		}, 150);
	}

	updateOffsets();
	applyStickyHeader();

	$(window).on('scroll', handleScroll);
	$(window).on('resize', handleResize);
});
